// src/pages/produccion/CoberturaPlantilla.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

function colorPorPorcentaje(p) {
  if (p === null || p === undefined) return '#8A7690';
  if (p >= 95) return '#3E7C5A';
  if (p >= 85) return '#B2662A';
  return '#B23A48';
}

function TarjetaTurno({ titulo, data }) {
  return (
    <div style={styles.tarjetaKpi}>
      <div style={styles.kpiLabel}>{titulo}</div>
      <div style={{ ...styles.kpiValor, color: colorPorPorcentaje(data?.porcentaje) }}>
        {data?.porcentaje !== null && data?.porcentaje !== undefined ? `${data.porcentaje}%` : '—'}
      </div>
      <div style={styles.kpiDetalle}>{data?.personal} / {data?.objetivo} personas</div>
    </div>
  );
}

function TablaAreas({ titulo, areas, objetivoTotal }) {
  const total = areas.reduce((s, a) => s + Number(a.personal), 0);
  return (
    <div style={styles.tarjeta}>
      <h3 style={styles.subtitulo2}>{titulo}</h3>
      {areas.length === 0 ? (
        <div style={styles.vacio}>Sin personal activo en este turno.</div>
      ) : (
        areas.map((a) => (
          <div key={a.area} style={styles.filaArea}>
            <div style={styles.nombreArea}>{a.area}</div>
            <div style={styles.barraContenedor}>
              <div style={{ ...styles.barra, width: `${Math.min((a.personal / total) * 100, 100)}%` }} />
            </div>
            <div style={styles.numeroArea}>{a.personal}</div>
          </div>
        ))
      )}
      <div style={styles.totalArea}>Total: {total} de {objetivoTotal} objetivo</div>
    </div>
  );
}

export default function CoberturaPlantilla() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get('/api/produccion/cobertura-plantilla').then((res) => {
      setDatos(res.data.data);
      setCargando(false);
    }).catch((err) => {
      console.error(err);
      setCargando(false);
    });
  }, []);

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;
  if (!datos) return <div style={styles.contenedor}>No se pudo cargar la cobertura de plantilla.</div>;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>1.7 Cobertura de Plantilla</h1>
      <p style={styles.subtitulo}>Plantilla actual (activos en roster) ÷ Plantilla autorizada, por turno. Datos en vivo desde Asistencias.</p>

      <div style={styles.tarjetasResumen}>
        <TarjetaTurno titulo="Turno Día" data={datos.dia} />
        <TarjetaTurno titulo="Turno Noche" data={datos.noche} />
      </div>

      <div style={styles.grid2}>
        <TablaAreas titulo="Desglose por área — Día" areas={datos.areasDia} objetivoTotal={datos.dia.objetivo} />
        <TablaAreas titulo="Desglose por área — Noche" areas={datos.areasNoche} objetivoTotal={datos.noche.objetivo} />
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '900px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  subtitulo2: { fontFamily: 'Playfair Display, serif', fontSize: '16px', color: '#2A1830', marginBottom: '12px' },
  tarjetasResumen: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '20px' },
  tarjetaKpi: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  kpiLabel: { fontSize: '12px', color: '#8A7690', marginBottom: '6px', fontWeight: 600 },
  kpiValor: { fontSize: '30px', fontWeight: 700 },
  kpiDetalle: { fontSize: '11px', color: '#8A7690', marginTop: '4px' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '16px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  vacio: { fontSize: '12px', color: '#8A7690' },
  filaArea: { display: 'grid', gridTemplateColumns: '110px 1fr 30px', alignItems: 'center', gap: '8px', marginBottom: '8px' },
  nombreArea: { fontSize: '12px', color: '#3A2E42', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  barraContenedor: { background: '#F0E9E0', borderRadius: '4px', height: '8px', overflow: 'hidden' },
  barra: { background: '#6A2C75', height: '100%', borderRadius: '4px' },
  numeroArea: { fontSize: '12px', fontWeight: 600, color: '#2A1830', textAlign: 'right' },
  totalArea: { fontSize: '11px', color: '#8A7690', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #F0E9E0' },
};